<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AmEa2P/tc-custom/9781504094917.jpg?1730581085887" alt="This image is the cover for the book Perfect Couple"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Perfect Couple
      </h1>
      <p class="bookDescription body article font2">
        <b>Their life looks so perfect on the surface. But the facade is beginning to crack . . .</b><br/><br/> Nevin and Gloria both have successful careers, as well as two adorable kids and a picture-book cottage by the sea. But at forty, Nevin is experiencing some discontent. He’s a successful author, but his latest plot is not for a book . . .<br/><br/> As Nevin sets a plan in motion that will allow him to escape his marriage, he conspires against Gloria. But he should have thought it through a little more. Because each of them have their own agenda, and everything is about to go very wrong.<br/><br/> There’s no such thing as a perfect marriage—or a perfect crime . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        N.J. Cracknell
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?06f3ea66